import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/estoque/unidades/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findUnidades(empresa_cnpj, perPage = 1000) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${perPage && `&per_page=${perPage}`}`,
    "GET",
    headers
  );
}
